var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.entity && !_vm.uninterruptedView
        ? _c("module-detail-header", {
            attrs: {
              entity: _vm.entity,
              "show-new": false,
              "show-print": _vm.entity && !_vm.entity.isNew,
              "show-delete":
                _vm.entity &&
                !_vm.entity.deleted &&
                !_vm.entity.isNew &&
                !_vm.readOnlyView &&
                !_vm.isInvoiced,
              "show-save": _vm.showSaveButton,
              "auto-save-enabled": _vm.autoSaveEnabled,
              "show-lock": _vm.showLock,
              "show-price-parts-msg":
                !_vm.entity.isNew && _vm.canViewPricePartsMsg,
              "show-quote-template": _vm.showQuoteTemplate,
              "quote-template-disabled": _vm.quoteTemplateDisabled,
              "quote-cancelled": _vm.isQuoteCancelledByInsurer,
              "show-auto-save": _vm.autoSaveEnabled,
              "auto-save-status": _vm.quoteSaveStatus,
              "is-saving": _vm.autoSaveStatus.isSaving || _vm.isSaving,
              "has-auto-save-failed": _vm.autoSaveStatus.isFailed,
              "unsaved-changes": _vm.autoSaveStatus.isDiffChanged,
              "auto-save-locked":
                (_vm.entity && _vm.entity.isNew) ||
                !_vm.autoSaveEnabled ||
                _vm.autoSaveStatus.isFailed,
              "show-calendar": _vm.isRepx,
              "show-additional-quote-buttons": _vm.showQuoteActionButton,
              "show-additional-quote": _vm.showNewAdditional,
              "show-toggle": false,
            },
            on: {
              appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked,
              "manual-save-request": _vm.handleManualSaveRequest,
              "toggle-auto-save": _vm.toggleAutoSave,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "desktop-left",
                  fn: function () {
                    return [
                      _c(
                        "article",
                        { staticClass: "horizontal-menu-article" },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.$user.info.isSupportUser &&
                                    _vm.hasFlexiShopIntegration,
                                  expression:
                                    "$user.info.isSupportUser && hasFlexiShopIntegration",
                                },
                              ],
                              staticClass: "icon is-synced-icon",
                              class: [
                                _vm.entity.isSynced
                                  ? "has-text-success"
                                  : "has-text-warning",
                              ],
                            },
                            [
                              _c("i", {
                                staticClass: "mdi mdi-circle-medium mdi-36px",
                              }),
                            ]
                          ),
                          _c("section", { staticClass: "quote-header-row" }, [
                            _c("div", { staticClass: "quote-info is-flex" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "is-5 is-flex is-align-items-center",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "is-size-4 has-text-weight-bold mx-1",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            [
                                              _vm.entity.prefix,
                                              _vm.entity.quoteNo,
                                              _vm.entity.suffix,
                                            ].join("") || "-"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "is-flex is-align-items-center" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "is-flex tooltip is-tooltip-bottom",
                                    attrs: {
                                      "data-tooltip": "Authorised Quote",
                                    },
                                  },
                                  [
                                    _vm.entity &&
                                    !_vm.entity.isNew &&
                                    _vm.isAuthorised
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "mso mso-24px has-text-grey-light",
                                          },
                                          [_vm._v(" shield ")]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm.entity.isNew || _vm.readOnlyView
                                  ? _c("div", { staticClass: "ml-1" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tag is-rounded job-stage is-5",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.jobNSubJobStageCompositeName
                                            )
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "field ml-1",
                                        staticStyle: { "margin-bottom": "0" },
                                      },
                                      [
                                        _c("div", { staticClass: "control" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "select job-stage-select",
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.innerJobNSubJobStageCompositeKey,
                                                      expression:
                                                        "innerJobNSubJobStageCompositeKey",
                                                    },
                                                  ],
                                                  staticStyle: {
                                                    "min-width": "150px",
                                                  },
                                                  on: {
                                                    change: [
                                                      function ($event) {
                                                        var $$selectedVal =
                                                          Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function (o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function (o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                        _vm.innerJobNSubJobStageCompositeKey =
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                      },
                                                      _vm.handleJobNSubJobStageChanged,
                                                    ],
                                                  },
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.jobNSubJobStagesOptions,
                                                    function (jobStageGroup) {
                                                      return [
                                                        jobStageGroup.subStages
                                                          .length === 0
                                                          ? _c(
                                                              "option",
                                                              {
                                                                key: `main-${jobStageGroup.jobStageId}`,
                                                                domProps: {
                                                                  value: `${jobStageGroup.mainStage.compositeKey}`,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.formatJobStage(
                                                                        jobStageGroup.jobStageName
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        jobStageGroup.subStages
                                                          .length > 0
                                                          ? _c(
                                                              "optgroup",
                                                              {
                                                                key: `group-${jobStageGroup.jobStageId}`,
                                                                attrs: {
                                                                  label:
                                                                    _vm.formatJobStage(
                                                                      jobStageGroup.jobStageName
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _vm.innerJobNSubJobStageCompositeKey ===
                                                                jobStageGroup
                                                                  .mainStage
                                                                  .compositeKey
                                                                  ? _c(
                                                                      "option",
                                                                      {
                                                                        key: `parent-${jobStageGroup.jobStageId}`,
                                                                        attrs: {
                                                                          disabled:
                                                                            "",
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            value: `${jobStageGroup.mainStage.compositeKey}`,
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.formatJobStage(
                                                                                jobStageGroup.jobStageName
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._l(
                                                                  jobStageGroup.subStages,
                                                                  function (
                                                                    subStage
                                                                  ) {
                                                                    return _c(
                                                                      "option",
                                                                      {
                                                                        key: subStage.compositeKey,
                                                                        attrs: {
                                                                          disabled:
                                                                            subStage.disabled,
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            value:
                                                                              subStage.compositeKey,
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.formatJobStage(
                                                                                subStage.subJobStageName
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                              ],
                                                              2
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                              ]
                            ),
                            _vm.entity &&
                            _vm.entity.subQuoteNos &&
                            _vm.entity.subQuoteNos.length >= 1 &&
                            !_vm.entity.isNew &&
                            !_vm.entity.isAssessmentEnabled
                              ? _c("div", { staticClass: "subquotes-tabs" }, [
                                  _c(
                                    "div",
                                    { staticClass: "tags" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "is-size-6 has-text-weight-semibold",
                                        },
                                        [_vm._v("Quote:")]
                                      ),
                                      _vm._l(
                                        _vm.entity.subQuoteNos,
                                        function (sub) {
                                          return _c(
                                            "router-link",
                                            {
                                              key: sub.key,
                                              staticClass: "tag is-rounded",
                                              class: {
                                                "is-primary":
                                                  sub.key ===
                                                  _vm.entity.subQuoteNo,
                                                "has-text-white":
                                                  sub.key ===
                                                  _vm.entity.subQuoteNo,
                                                "is-disabled":
                                                  _vm.entity.isNew &&
                                                  sub.key !==
                                                    _vm.entity.subQuoteNo,
                                              },
                                              attrs: {
                                                to: {
                                                  name: _vm.$route.name,
                                                  params: {
                                                    quoteId: sub.value,
                                                  },
                                                  query: _vm.$route.query,
                                                },
                                                exact: "",
                                              },
                                              nativeOn: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.goToRoute({
                                                    name: _vm.$route.name,
                                                    params: {
                                                      quoteId: sub.value,
                                                    },
                                                    query: _vm.$route.query,
                                                  })
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.entity
                                                          .readOnlyStatuses[
                                                          sub.key
                                                        ],
                                                      expression:
                                                        "entity.readOnlyStatuses[sub.key]",
                                                    },
                                                  ],
                                                  staticClass: "icon is-small",
                                                  staticStyle: {
                                                    "margin-left": "0.1em",
                                                    "margin-right": "0.1em",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon mdi mdi-lock-outline",
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  class: {
                                                    "has-badge-warning has-badge-small has-badge-rounded has-badge-offset2":
                                                      _vm.entity.isNew &&
                                                      sub.key ===
                                                        _vm.currentsubquote,
                                                  },
                                                  attrs: {
                                                    "data-badge":
                                                      _vm.entity.isNew &&
                                                      sub.key ===
                                                        _vm.currentsubquote
                                                        ? ""
                                                        : null,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        sub.key === 0
                                                          ? "Main"
                                                          : `Add-${sub.key}`
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ])
                              : _vm._e(),
                            !_vm.entity.isNew
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "is-flex quote-header-info thin-scrollbar",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "is-flex is-hidden-desktop-only",
                                      },
                                      [
                                        _vm.customer
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mr-5 is-flex is-align-items-center is-info tooltip is-tooltip-bottom",
                                                attrs: {
                                                  "data-tooltip":
                                                    _vm.customer.fullname,
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mso mso-24px has-text-grey-light mr-1",
                                                  },
                                                  [_vm._v("person")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "has-text-weight-semibold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.truncate(
                                                          _vm.customer.fullname,
                                                          _vm.customerAndVehicleMakeModelMaxLength
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.vehicle
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex is-align-items-center is-info tooltip is-tooltip-bottom",
                                                attrs: {
                                                  "data-tooltip": `${_vm.vehicle.rego} - ${_vm.vehicle.model.name}`,
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mso mso-24px has-text-grey-light mr-1",
                                                  },
                                                  [_vm._v("directions_car")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "has-text-weight-semibold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.truncate(
                                                          `${_vm.vehicle.rego} - ${_vm.vehicle.model.name}`,
                                                          _vm.customerAndVehicleMakeModelMaxLength
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "is-flex",
                                        staticStyle: { gap: "0.7rem" },
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "is-size-6 has-text-weight-semibold",
                                            },
                                            [
                                              _vm._v("Total "),
                                              _c(
                                                "span",
                                                { staticClass: "subtext mr-2" },
                                                [_vm._v("(Ex GST)")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "has-text-success" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$filters.formatCurrency(
                                                    _vm.totalExGst,
                                                    _vm.$userInfo.locale
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "is-size-6 has-text-weight-semibold",
                                            },
                                            [
                                              _vm._v("Total "),
                                              _c(
                                                "span",
                                                { staticClass: "subtext mr-2" },
                                                [_vm._v("(Inc GST)")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "has-text-success" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$filters.formatCurrency(
                                                    _vm.totalIncGst,
                                                    _vm.$userInfo.locale
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                _vm.isQuoteCancelledByInsurer
                  ? {
                      key: "center",
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { staticClass: "is-size-6 tag is-danger is-light" },
                            [
                              _c("span", {
                                staticClass: "mdi mdi-alert-outline mr-3",
                              }),
                              _c(
                                "span",
                                { staticStyle: { "word-break": "break-word" } },
                                [
                                  _vm._v(
                                    "Cancelled by insurer. Please copy the quote to work on it as a private job."
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                {
                  key: "more-menu-items",
                  fn: function () {
                    return [
                      _vm.entity && !_vm.entity.isNew && _vm.entity.deleted
                        ? _c("div", { staticClass: "is-divider" })
                        : _vm._e(),
                      _vm.entity && !_vm.entity.isNew && _vm.entity.deleted
                        ? _c("li", [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "is-flex is-align-items-center has-text-success",
                                on: {
                                  click: function ($event) {
                                    return _vm.onHeaderButtonClicked("restore")
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "mso mso-20px icon pr-3" },
                                  [_vm._v(" restore_from_trash ")]
                                ),
                                _c("span", [_vm._v("Restore")]),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      (_vm.$userInfo.isSupportUser ||
                        _vm.$userInfo.isCustomerAdministrator ||
                        _vm.tempGemCan) &&
                      _vm.isMainQuote
                        ? _c("div")
                        : _vm._e(),
                      (_vm.$userInfo.isSupportUser ||
                        _vm.$userInfo.isCustomerAdministrator ||
                        _vm.tempGemCan) &&
                      _vm.isMainQuote
                        ? _c("li", [
                            _c(
                              "a",
                              {
                                staticClass: "is-flex is-align-items-center",
                                on: {
                                  click: function ($event) {
                                    return _vm.onHeaderButtonClicked(
                                      "enableAssessmentHistory"
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "mso mso-20px icon pr-3" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.entity.isAssessmentEnabled
                                            ? "check_box"
                                            : "check_box_outline_blank"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c("span", [
                                  _vm._v("Enable Assessment History"),
                                ]),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm.entity && !_vm.uninterruptedView && _vm.showHorizontalMenu
        ? _c("quote-sub-nav", {
            attrs: {
              value: _vm.entity,
              insurer: _vm.insurer,
              "orm-unread-message-count": _vm.ormUnreadMessageCount,
            },
          })
        : _vm._e(),
      !_vm.isOrmEditedQuote
        ? _c("QuoteBanner", {
            attrs: {
              title: "Quote Editing Locked",
              message:
                "Editing is disabled while a payment authorisation is in progress.",
              type: "warning",
              icon: "warning",
              "banner-visible": true,
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "columns is-gapless quote-body" }, [
        _vm.isQuoteBuilder
          ? _c(
              "div",
              { staticClass: "column is-narrow ml-3 mb-3" },
              [
                _c("quote-builder-sidebar", {
                  attrs: {
                    "selected-menu": _vm.selectedMenu,
                    "selected-sub-sections": _vm.selectedSubSections,
                    "selected-area": _vm.selectedArea,
                    "available-items-type": _vm.availableItemsType,
                    "is-quote-editable": _vm.isQuoteEditable,
                  },
                  on: {
                    "update:selectedSubSections": function ($event) {
                      _vm.selectedSubSections = $event
                    },
                    "update:selected-sub-sections": function ($event) {
                      _vm.selectedSubSections = $event
                    },
                    "update:selectedArea": function ($event) {
                      _vm.selectedArea = $event
                    },
                    "update:selected-area": function ($event) {
                      _vm.selectedArea = $event
                    },
                    "update:selectedMenu": function ($event) {
                      _vm.selectedMenu = $event
                    },
                    modify: _vm.modifySelections,
                    reset: _vm.resetSelections,
                  },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "column mx-3 mt-0 mb-3" },
          [
            _vm.entity && _vm.vehicle && _vm.customer && _vm.insurer
              ? _c("router-view", {
                  key: _vm.$route.fullPath,
                  ref: "routerView",
                  attrs: {
                    "is-tiled": false,
                    "route-name": _vm.$route.name,
                    vehicle: _vm.vehicle,
                    customer: _vm.customer,
                    insurer: _vm.insurer,
                    "quote-cycle-time": _vm.entity.quoteCycleTime,
                    "next-line-number": _vm.nextLineNumber,
                    "read-only-view": _vm.readOnlyView,
                    "audanet-lock": _vm.audanetLock,
                    "price-parts-return-route": _vm.pricePartsReturnRoute,
                    "snapshot-diff": _vm.snapshotDiff,
                    "orm-unread-message-count": _vm.ormUnreadMessageCount,
                    "show-quote-template": _vm.showQuoteTemplate,
                    "selected-area": _vm.selectedArea,
                    "selected-sub-sections": _vm.selectedSubSections,
                    "is-new-customer-prompt": _vm.isNewCustomerPrompt,
                    "header-saving-panels": _vm.headerSavingPanels,
                    "is-quote-editable": _vm.isQuoteEditable,
                    "auto-save-enabled": _vm.autoSaveEnabled,
                  },
                  on: {
                    "update:vehicle": function ($event) {
                      _vm.vehicle = $event
                    },
                    "update:customer": function ($event) {
                      _vm.customer = $event
                    },
                    "update:insurer": function ($event) {
                      _vm.insurer = $event
                    },
                    "update:quoteCycleTime": function ($event) {
                      return _vm.$set(_vm.entity, "quoteCycleTime", $event)
                    },
                    "update:quote-cycle-time": function ($event) {
                      return _vm.$set(_vm.entity, "quoteCycleTime", $event)
                    },
                    onOpgCodeChanged: _vm.onOpgCodeChanged,
                    "customer-component-blur": function ($event) {
                      return _vm.queueHeaderAutosave("customer")
                    },
                    "vehicle-component-blur": function ($event) {
                      return _vm.queueHeaderAutosave("vehicle")
                    },
                    "insurer-component-blur": function ($event) {
                      return _vm.queueHeaderAutosave("insurer")
                    },
                    "booking-component-blur": function ($event) {
                      return _vm.queueHeaderAutosave("booking")
                    },
                    "remarks-save-state-change": _vm.onRemarksSaveStateChange,
                    "remarks-saved": _vm.onRemarksSaved,
                    updateQuoteItemsDefaultPaintGroup:
                      _vm.updateQuoteItemsDefaultPaintGroup,
                    getEntity: _vm.getEntity,
                    "select-vehicle": _vm.selectVehicle,
                    "select-customer": _vm.selectCustomer,
                    "select-insurer": _vm.selectInsurer,
                    save: _vm.save,
                    "hide-header-buttons": _vm.hideHeaderButtons,
                    downloadPartsCheckPrice: _vm.downloadPartsCheckPrice,
                    addRepairQuoteTemplateItems: (id) =>
                      _vm.addRepairQuoteTemplateItems(id),
                    handleAddTemplateItemsCustom: (obj) =>
                      _vm.addRepairQuoteTemplateItemsCustom(obj),
                    "save-repx-repair-stages": _vm.handleSaveRepxRepairStages,
                    avaliableItemsTypeChanged: _vm.availableItemsTypeChanged,
                    "update:selectedMenu": function ($event) {
                      _vm.selectedMenu = $event
                    },
                  },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm.isPrintOptionsActive
        ? _c(
            "print-options-modal",
            {
              attrs: {
                active: _vm.isPrintOptionsActive,
                "show-icon": true,
                "attach-disabled": false,
                "cancel-disabled": false,
                value: _vm.entity,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isPrintOptionsActive = $event
                },
                cancel: function ($event) {
                  return _vm.closeModal()
                },
                ok: function ($event) {
                  return _vm.closeModal()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Print Options"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.isInvoicePrintOptionsActive
        ? _c(
            "invoice-print-options-modal",
            {
              attrs: {
                active: _vm.isInvoicePrintOptionsActive,
                "show-icon": true,
                "cancel-disabled": false,
                value: _vm.entity,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isInvoicePrintOptionsActive = $event
                },
                ok: function ($event) {
                  _vm.isInvoicePrintOptionsActive = false
                },
                cancel: function ($event) {
                  _vm.isInvoicePrintOptionsActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Invoice Print Options"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.isSmsModalActive
        ? _c("sms-modal", {
            attrs: { active: _vm.isSmsModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isSmsModalActive = $event
              },
              close: _vm.closeSmsModal,
            },
            model: {
              value: _vm.smsDetails,
              callback: function ($$v) {
                _vm.smsDetails = $$v
              },
              expression: "smsDetails",
            },
          })
        : _vm._e(),
      _vm.isCopyQuoteModalActive
        ? _c("copy-quote-modal", {
            attrs: {
              active: _vm.isCopyQuoteModalActive,
              "image-ids": _vm.imageIds,
            },
            on: {
              "update:active": function ($event) {
                _vm.isCopyQuoteModalActive = $event
              },
              copy: _vm.copyQuote,
              cancel: function ($event) {
                _vm.isCopyQuoteModalActive = false
              },
            },
            model: {
              value: _vm.entity,
              callback: function ($$v) {
                _vm.entity = $$v
              },
              expression: "entity",
            },
          })
        : _vm._e(),
      _vm.isQuoteExportModalActive
        ? _c("quote-export-modal", {
            attrs: {
              active: _vm.isQuoteExportModalActive,
              vehicle: _vm.quoteVehicle,
              "default-email": _vm.insurerDefaultEmail,
            },
            on: {
              "update:active": function ($event) {
                _vm.isQuoteExportModalActive = $event
              },
              close: _vm.closeQuoteExportModal,
            },
            model: {
              value: _vm.entity,
              callback: function ($$v) {
                _vm.entity = $$v
              },
              expression: "entity",
            },
          })
        : _vm._e(),
      _vm.isNavigationWarningModalActive
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isNavigationWarningModalActive,
                "ok-text":
                  _vm.navigationWarningAction === "deleteEmpty"
                    ? "Continue"
                    : _vm.navigationWarningAction === "leaveWithErrors"
                    ? "Leave Anyway"
                    : "Try Manual Save",
                "cancel-text":
                  _vm.navigationWarningAction === "deleteEmpty"
                    ? "Keep Editing"
                    : _vm.navigationWarningAction === "leaveWithErrors"
                    ? "Stay to Fix"
                    : "Skip Anyway",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isNavigationWarningModalActive = $event
                },
                ok: function ($event) {
                  return _vm.handleNavigationWarningConfirm()
                },
                cancel: function ($event) {
                  return _vm.handleNavigationWarningCancel()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Navigation Warning"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [_vm._v(_vm._s(_vm.navigationWarningMessage))]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "unsaved-modal",
        {
          attrs: { active: _vm.isUnsavedModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            skipSave: function ($event) {
              return _vm.skipSave()
            },
            saveContinue: function ($event) {
              return _vm.saveContinue()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Unsaved Changes"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v("There are unsaved changes. Please select action below"),
          ]),
        ]
      ),
      _vm.entity
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.deleteEntity(true)
                },
                cancel: function ($event) {
                  return _vm.deleteEntity(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v(
                  "Delete " +
                    _vm._s(_vm.entity.subQuoteNo > 0 ? "Supplementry" : "") +
                    " Quote"
                ),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.entity.subQuoteNo > 0 ? "Supplementry" : "") +
                      " Quote "
                  ),
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(`${_vm.deleteQuoteMessage}`))]
                  ),
                  _vm._v(" will be deleted. Continue? "),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "confirm-modal",
        {
          attrs: {
            active: _vm.isCustomerCreateModifyModalActive,
            "ok-text": "Save",
            "cancel-text": "Cancel",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCustomerCreateModifyModalActive = $event
            },
            ok: _vm.handleCustomerModalSave,
            cancel: _vm.handleCustomerModalCancel,
          },
        },
        [
          _c("div", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Update Customer"),
          ]),
          _c("div", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _c("div", { staticClass: "new-owner-prompt-container" }, [
              _c("p", { staticClass: "has-text-weight-bold mb-5" }, [
                _vm._v(
                  "You are about to update the customer details. What would you like to do?"
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "field",
                  class: `theme-${_vm.$theme.name} has-background-${_vm.$theme.name}`,
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "custom-radio radio is-flex p-4 mb-3",
                      class: [
                        {
                          "is-selected":
                            _vm.customerModalSelection === "create",
                        },
                        _vm.customerModalSelection === "create" &&
                          `has-text-${_vm.$theme.name}-invert`,
                      ],
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.customerModalSelection,
                            expression: "customerModalSelection",
                          },
                        ],
                        attrs: { type: "radio", value: "create" },
                        domProps: {
                          checked: _vm._q(_vm.customerModalSelection, "create"),
                        },
                        on: {
                          change: function ($event) {
                            _vm.customerModalSelection = "create"
                          },
                        },
                      }),
                      _c("span", { staticClass: "check" }),
                      _c("span", { staticClass: "control-label ml-3" }, [
                        _vm._v(
                          " Create a new customer profile and assign the vehicle to them. A new vehicle record will be created with the same registration, linked to a new customer. "
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "field",
                  class: `theme-${_vm.$theme.name} has-background-${_vm.$theme.name}`,
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "custom-radio radio is-flex p-4",
                      class: [
                        {
                          "is-selected":
                            _vm.customerModalSelection === "modify",
                        },
                        _vm.customerModalSelection === "modify" &&
                          `has-text-${_vm.$theme.name}-invert`,
                      ],
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.customerModalSelection,
                            expression: "customerModalSelection",
                          },
                        ],
                        attrs: { type: "radio", value: "modify" },
                        domProps: {
                          checked: _vm._q(_vm.customerModalSelection, "modify"),
                        },
                        on: {
                          change: function ($event) {
                            _vm.customerModalSelection = "modify"
                          },
                        },
                      }),
                      _c("span", { staticClass: "check" }),
                      _c("span", { staticClass: "control-label ml-3" }, [
                        _vm._v(
                          " Update the existing customer's details. All quotes "
                        ),
                        _c("b", [
                          _vm._v("( " + _vm._s(_vm.affectedQuotesCount) + " )"),
                        ]),
                        _vm._v(
                          " with this registration will be updated with the customer information. "
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _vm.entity
        ? _c(
            "save-conflict-modal",
            {
              attrs: { active: _vm.isSaveConflictModalActive },
              on: {
                "update:active": function ($event) {
                  _vm.isSaveConflictModalActive = $event
                },
                merge: _vm.conflictMerge,
                reload: _vm.conflictReload,
                close: function ($event) {
                  _vm.isSaveConflictModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Quote Conflict"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(" Quote "),
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [
                      _vm._v(
                        _vm._s(
                          `${_vm.entity.prefix}${_vm.entity.quoteNo}${_vm.entity.suffix}`
                        )
                      ),
                    ]
                  ),
                  _vm._v(" is newer on the server. Reload/Merge/Cancel? "),
                  _c("br"),
                  _c("br"),
                  _c("span", { staticClass: "has-text-weight-bold" }, [
                    _vm._v("Reload"),
                  ]),
                  _vm._v(" - "),
                  _c("span", { staticClass: "is-italic" }, [
                    _vm._v("Reload quote and lose changes"),
                  ]),
                  _c("br"),
                  _c("span", { staticClass: "has-text-weight-bold" }, [
                    _vm._v("Merge"),
                  ]),
                  _vm._v(" - "),
                  _c("span", { staticClass: "is-italic" }, [
                    _vm._v(
                      "Local quote changes take precedence. Added items will be merged"
                    ),
                  ]),
                  _c("br"),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.isXmlViewerModalActive
        ? _c(
            "xml-viewer-modal",
            {
              attrs: {
                active: _vm.isXmlViewerModalActive,
                "quote-id": _vm.entity.quoteId,
                "message-type": _vm.messageType,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isXmlViewerModalActive = $event
                },
                close: function ($event) {
                  _vm.isXmlViewerModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("View " + _vm._s(_vm.messageType) + " Messages"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.isQuoteTemplateModalActive
        ? _c(
            "quote-template-apply-modal",
            {
              attrs: {
                active: _vm.isQuoteTemplateModalActive,
                "quote-times-type": _vm.entity.labourType,
                "vehicle-body-id": _vm.vehicle.bodyId,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isQuoteTemplateModalActive = $event
                },
                add: _vm.addRepairQuoteTemplateItems,
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Apply Quote Template"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.isVehicleButterflyModalActive
        ? _c("vehicle-butter-fly-selector-modal", {
            attrs: {
              active: _vm.isVehicleButterflyModalActive,
              entity: _vm.entity,
            },
            on: {
              "update:active": function ($event) {
                _vm.isVehicleButterflyModalActive = $event
              },
              done: _vm.handleVehicleButterflyDone,
              cancel: _vm.handleVehicleButterflyCancel,
            },
            model: {
              value: _vm.selectedSubSections,
              callback: function ($$v) {
                _vm.selectedSubSections = $$v
              },
              expression: "selectedSubSections",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }